import clsx from 'clsx'
import { BasicStyledComponent, DSNumberInfo } from 'shared-definitions/types'
import NumberInfoIcon from '../service/NumberInfoIcon'
import styles from './NumbersLists.module.css'

interface NumbersListProps {
  numbers: DSNumberInfo[]
}

const NumbersList: React.VFC<NumbersListProps & BasicStyledComponent> = ({
  className,
  numbers,
}) => (
  <ul className={clsx(styles.numbers, className)}>
    {numbers.map((number, index) => (
      <li key={index} className={styles.numbersOne}>
        <div className={styles.numbersIconWrapper}>
          <NumberInfoIcon icon={number.icon} className={styles.numbersIcon} />
        </div>
        <h3 className={styles.numbersTitle}>{number.title}</h3>
        {number.subTitle && <div className={styles.numbersSubTitle}>{number.subTitle}</div>}
      </li>
    ))}
  </ul>
)

export default NumbersList
